module.exports = __webpack_public_path__ + "static/media/close.21982114.svg";